export default __webpack_public_path__ + "static/media/horse.454c44c1.jpg";